// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerSignInStyles } from "@insite/content-library/Widgets/Common/HeaderSignIn";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

(headerSignInStyles as any).signOutTypography = {
    weight: 600,
    color: " primary",
    size: 12,
};

(headerSignInStyles as any).userElementIcon = {
    size: 23,
    src: "IconHeaderAccountInactive",
    css: css`
        margin-right: 6px;
    `,
};
(headerSignInStyles as any).mobileElementIcon = {
    size: 20,
    src: "IconHeaderAccountInactive",
    color: "primary",
};

(headerSignInStyles as any).titleClickable = {
    css: css`
        ${(headerSignInStyles as any).titleClickable?.css};
        .account-icon {
            &.toggle svg {
                color: ${getColor("primary")};
            }
        }
    `,
};
